import { IonButton, useIonAlert } from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import { resetCreatedCounter, setCreateStatus } from '../../../store/massiveDocumentCreate'
import { createDocumentFromTemplate } from '../../../store/massiveDocumentCreate/actions/createDocumentFromTemplate'
import { createMasiveDocumentProcess } from '../../../store/massiveDocumentCreate/actions/createMassiveDocumentProcess'
import { selectSelectedUsers } from '../../../store/massiveDocumentCreate/selectors/selectSelectedUsers'
import { selectShowCreateButton } from '../../../store/massiveDocumentCreate/selectors/selectShowCreateButton'
import { setProcessId } from '../../../store/massiveDocumentCreate'
import { selectFormData } from '../../../store/massiveDocumentCreate/selectors/selectFormData'
import { createDocument } from '../../../store/documentCreate/actions/createDocumentBasic'
import addSigner from '../../../store/documentShow/actions/addSigner'
import { incrementCreatedCounter } from '../../../store/massiveDocumentCreate'
import { setDocumentPending } from '../../../store/documentUpdate/actions/setDocumentPending'
import { useIonToast } from '@ionic/react'

export const ConfirmButton = () => {
  const dispatch = useDispatch()

  const [present] = useIonAlert()
  const [presentToast] = useIonToast()
  const selectedUsers = useSelector(selectSelectedUsers)
  const showButton = useSelector(selectShowCreateButton)
  const codeOfUsersToGet = selectedUsers.map((user) => user.code)
  const creationData = useSelector(selectFormData)
  const isArchivo = creationData.creationType === 'archivo'
  const legalRep = creationData.legalRep

  // Nuevo: detectar si la plantilla trae un archivo configurado
  const templateHasArchive = !isArchivo && Boolean(creationData?.template?.archive)
  // Selecciona el archivo a usar (archivo directo o el de la plantilla)
  const archiveForCreation = isArchivo
    ? creationData.archive
    : (templateHasArchive ? creationData.template.archive : null)

  const onSubmit = async () => {
    dispatch(setCreateStatus('pending'))
    dispatch(setProcessId(0))
    dispatch(resetCreatedCounter());

    const failedUsers: string[] = []

    let successCount = 0
    for (const { user } of selectedUsers) {
      try {
        if (isArchivo || templateHasArchive) {
          const formData = {
            ...creationData,
            // Forzamos el archivo a usar: si es plantilla con archivo, usamos el de la plantilla
            archive: archiveForCreation,
            title: `${creationData.title?.trim()} ${user.name?.trim()}`
          }

          // 1. Crear documento (con archivo)
          const { payload: documentCreated }: any = await dispatch(createDocument(formData))
          if (!documentCreated) {
            console.error('No se pudo crear el acuerdo para', user)
            failedUsers.push(user.name || 'Usuario sin nombre')
            continue
          }

          // 2. Agregar representante legal si corresponde
          if (legalRep && legalRep.id !== user.id) {
            await dispatch(addSigner({ idUser: legalRep.id, idDoc: documentCreated.id }))
          }

          // 3. Agregar firmante principal
          await dispatch(addSigner({ idUser: user.id, idDoc: documentCreated.id }))

          // 4. Activar documento
          const result: any = await dispatch(setDocumentPending(documentCreated.id))
          if (result.type === setDocumentPending.rejected.type) {
             presentToast({
              message: `Error al activar el acuerdo para ${user.name}`,
              duration: 5000,
              color: 'danger'
            })
            failedUsers.push(user.name || 'Usuario sin nombre')
            continue
          }

          // 5. Contador
          dispatch(incrementCreatedCounter())
          successCount++
        } else {
          // Plantilla sin archivo asociado -> flujo original de plantilla
          const result: any = await dispatch(createDocumentFromTemplate([user, codeOfUsersToGet]))

          if (result?.payload?.status === 'success') {
            successCount++
          } else {
            presentToast({
              message: `Error al crear acuerdo para ${user.name} usando plantilla.`,
              duration: 5000,
              color: 'danger'
            })
            failedUsers.push(user.name || 'Usuario sin nombre')
            console.error('❌ Error en createDocumentFromTemplate para', user, result)
          }
        }
      } catch (error) {
        console.error('Error al crear acuerdo para', user, error)
        presentToast({
          message: `Error inesperado para ${user.name}`,
          duration: 5000,
          color: 'danger'
        })
        failedUsers.push(user.name || 'Usuario sin nombre')
      }
    }

    localStorage.setItem('failedUsers', JSON.stringify(failedUsers))
    dispatch(setCreateStatus('fulfilled'))

    if (successCount > 0) {
      // Espera opcional para dejar visible el modal
      setTimeout(() => {
        // Podrías limpiar otros estados aquí si es necesario
      }, 2000)
    } else {
      await presentToast({
        message: 'No se pudo crear ningún acuerdo.',
        duration: 5000,
        color: 'danger'
      })
    }
  }

  return (
    <>
      <IonButton
        fill="solid"
        size="large"
        color="secondary"
        disabled={!showButton}
        onClick={() => {
          present({
            header: `¿Deseas crear y activar ${selectedUsers.length} ${selectedUsers.length === 1 ? 'acuerdo' : 'acuerdos'}?`,
            buttons: [
              'No',
              {
                text: `Crear ${selectedUsers.length} ${selectedUsers.length === 1 ? 'acuerdo' : 'acuerdos'}`,
                handler: () => onSubmit()
              }
            ]
          })
        }}>
        Crear acuerdos
      </IonButton>
    </>
  )
}
